export enum WorkflowView {
  InProgress = 'In progress',
  Total = 'Total',
}
